import React from "react";
import { IonIcon } from "@ionic/react";
import { businessOutline, locationOutline } from "ionicons/icons";
import { ShareableOrg } from "../../../services/orgSharing";

// A single organization row: circular org icon + name with a trailing action slot. Locations
// render flat as "Parent · Location" (parentName passed by the caller from the org name map),
// differentiated from parent orgs by a location pin icon. Shared by the discovery picker and the
// invite popup list so the icon + layout stay identical in one place.
type Props = {
  org: ShareableOrg;
  /** Parent org name, when this org is a location — renders "Parent · Location". */
  parentName?: string;
  /** Trailing control (Share / Connected / Not available). */
  trailing: React.ReactNode;
};

const OrgRow: React.FC<Props> = ({ org, parentName, trailing }) => {
  const isLocation = org.parent_id != null;
  const label = isLocation && parentName ? `${parentName} · ${org.name}` : org.name;
  return (
    <div className="care-org-row">
      <div className="care-org-row-lead">
        <div className={`care-org-avatar${isLocation ? " is-location" : ""}`}>
          <IonIcon icon={isLocation ? locationOutline : businessOutline} />
        </div>
        <div style={{ minWidth: 0 }}>
          <div className="care-org-row-name">{label}</div>
          {/* The whole address (F-468) so the patient can confirm the location; the city alone
              when the kernel sends no address. */}
          {(org.address || org.city) && (
            <div className="care-org-row-meta care-org-row-address">{org.address || org.city}</div>
          )}
        </div>
      </div>
      {trailing}
    </div>
  );
};

export default OrgRow;
